/**
 * Relative path to return to after Google sign-in (from ProtectedRoute redirect state).
 * @param {{ state?: { from?: { pathname?: string, search?: string, hash?: string } } } | undefined} location
 * @returns {string|null}
 */
export function authReturnToFromLocation(location) {
  const from = location?.state?.from;
  if (!from?.pathname || !String(from.pathname).startsWith('/')) return null;
  return `${from.pathname}${from.search || ''}${from.hash || ''}`;
}

/**
 * @param {string|null|undefined} returnTo
 * @returns {string|null}
 */
export function sanitizeAuthReturnTo(returnTo) {
  if (returnTo == null || String(returnTo).trim() === '') return null;
  const path = String(returnTo).trim();
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  if (path.includes('://')) return null;
  return path;
}
